import React from 'react'

import BaseSkeleton from 'components/Skeleton/BaseSkeleton'

import {
  SkeletonActions,
  SkeletonBody,
  SkeletonProgress,
  SkeletonRoot,
} from './styled'

export default function SurveySkeleton() {
  return (
    <SkeletonRoot>
      <SkeletonProgress>
        {Array.from({ length: 5 }).map((_, index) => (
          <BaseSkeleton borderRadius={999} height={28} key={index} width={96} />
        ))}
      </SkeletonProgress>
      <SkeletonBody>
        <BaseSkeleton height={16} width={110} />
        <BaseSkeleton height={34} width="82%" />
        <BaseSkeleton height={18} width="58%" />
        <BaseSkeleton borderRadius={14} height={64} />
        <BaseSkeleton borderRadius={14} height={64} />
        <SkeletonActions>
          <BaseSkeleton borderRadius={12} height={45} width={112} />
          <BaseSkeleton borderRadius={12} height={45} width={132} />
        </SkeletonActions>
      </SkeletonBody>
    </SkeletonRoot>
  )
}
